var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"errors-container",class:_vm.classList},[_c('ul',_vm._l((_vm.errors),function(error,index){return _c('li',{key:index,domProps:{"innerHTML":_vm._s(error)}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }